/**
 * A screen's title, in the same green card Home's hero uses.
 *
 * A component rather than a ScreenShell prop because on the checkout screens
 * it belongs *under* the stepper: the stepper says where you are in the flow,
 * the title says what this step asks for. The shell's own `title` prop renders
 * the identical card for screens that have no stepper above it.
 */

import { memo } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { colors, radius, space } from '../../theme';
import { Text } from '../common/Text';

export interface ScreenTitleProps {
  title: string;
  subtitle?: string;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

export const ScreenTitle = memo(function ScreenTitle({
  title,
  subtitle,
  style,
  testID = 'screen-title',
}: ScreenTitleProps) {
  return (
    <View style={[styles.card, style]} testID={testID}>
      <Text variant="cardScreenTitle" tone="brand" align="center">
        {title}
      </Text>
      {subtitle ? (
        <Text variant="screenSubtitle" tone="secondary" align="center" style={styles.subtitle}>
          {subtitle}
        </Text>
      ) : null}
    </View>
  );
});

const styles = StyleSheet.create({
  card: {
    paddingVertical: space.md,
    paddingHorizontal: space.md,
    borderRadius: radius.lg,
    backgroundColor: colors.bg.brandSubtle,
  },
  subtitle: {
    marginTop: space.xs,
  },
});
